import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getZonesProjectsReports() {
      const state = getState();

      return state ? state.reports : [];
    },
    isZonesProjectsReportsRetrievalRequestFailure() {
      const state = getState();

      return state ? state.request.isFailure : false;
    },
    isZonesProjectsReportsRetrievalRequestPending() {
      const state = getState();

      return state ? state.request.isPending : false;
    },
    isZonesProjectsReportsRetrievalRequestSuccess() {
      const state = getState();

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
